import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "plus-small, add small" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M10.5 5.41666V9.99999M10.5 9.99999V14.5833M10.5 9.99999H5.91669M10.5 9.99999H15.0834",
        stroke: "currentColor",
        "stroke-linecap": "square"
      })
    ], -1)
  ])))
}
export default { render: render }